import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableFooter from '@mui/material/TableFooter'
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import './applicationTableTravelInfo.scss' 


const  ApplicationTableTravelInfo = ({ applicationData}) => {

  
  return (
            
    <div className='item'>
       
        <div className="details">

          {/* <h3 className='itemTitle'>{applicationData.firstname} {applicationData.surname}</h3> */}
          <div className='detailItem'>
            <span className='itemKey'>Destination:</span>
            <span className='itemValue'>{applicationData.country}</span>
          </div>
          <div className='detailItem'>
            <span className='itemKey'>Purpose of Travel:</span>
            <span className='itemValue'>{applicationData.travelPurpose}</span>
          </div>
          <div className='detailItem'>
            <span className='itemKey'>Visa Type:</span>
            <span className='itemValue'>{applicationData.visaType}</span>
          </div>
      
        </div>
    </div>
   
  );
}

export default ApplicationTableTravelInfo